import { useTranslation } from '@wix/wix-i18n-config';

import useIsKbServiceEnabled from '../../hooks/useIsKbServiceEnabled';

export type ResolveBabelSeo = <T extends string | undefined>(
  key: string,
  fallback: T,
  params?: Record<string, string>,
) => T | string;

export const useBabelSeo = (): ResolveBabelSeo => {
  const { t } = useTranslation();
  const enabled = useIsKbServiceEnabled();

  return (key, fallback, params) => {
    if (!enabled) {
      return fallback;
    }
    const resolved = t(key, params);
    if (!resolved || resolved === key) {
      return fallback;
    }
    return resolved;
  };
};
